import {useDisplayMobile} from '@/logged/common/composables';
import {pinia} from '@/logged/common/pinia';
import {defineStore} from 'pinia';
import {ref, watch} from 'vue';
import {useActiveRoute, useNavigationTabs, useMobileNavBar} from './composables';
import {useExpandedTabs} from './stores';

export const useAsideMenu = defineStore(
    'aside-menu',
    () => {
        /* For persistence, hydration is performed after Mount */
        const hydrateFromCache = ref(false);

        const expandedTabsStore = useExpandedTabs();

        // - Display modes and mobile mode

        const {isDisplayMobile} = useDisplayMobile();
        const {isMobileNavBarOpened, setMobileNavBarOpened, toggleMobileNavBarOpened} = useMobileNavBar();

        // - Tab list

        const {logoNavigationRoute, allNavigationRoutes, cachedNavigationRoutes, filteredNavigationRoutes} = useNavigationTabs();

        // - Active tab

        const {currentActiveRoute, pathname} = useActiveRoute();

        watch(
            [currentActiveRoute, () => expandedTabsStore.hydrated],
            () => {
                if (currentActiveRoute.value && expandedTabsStore.hydrated) {
                    const getParentTab = filteredNavigationRoutes.value.find(
                        (tab) => !!tab.children && !!tab.children.find((child) => child.id === currentActiveRoute.value),
                    );
                    if (getParentTab && !expandedTabsStore.expandedTabs.includes(getParentTab.id)) {
                        expandedTabsStore.toggleExpandTab(getParentTab.id);
                    }
                }
            },
            {immediate: true},
        );

        return {
            hydrateFromCache,
            currentActiveRoute,
            logoNavigationRoute,
            allNavigationRoutes,
            cachedNavigationRoutes,
            filteredNavigationRoutes,
            isDisplayMobile,
            isMobileNavBarOpened,
            setMobileNavBarOpened,
            toggleMobileNavBarOpened,
            pathname,
        };
    },
    {
        persist: {
            storage: window.sessionStorage,
            paths: ['cachedNavigationRoutes'],
            serializer: {
                deserialize(value) {
                    const asideMenu = useAsideMenu(pinia);
                    const deserializedStore = JSON.parse(value);
                    if ('cachedNavigationRoutes' in deserializedStore) {
                        asideMenu.hydrateFromCache = true;
                    }
                    return deserializedStore;
                },
                serialize: JSON.stringify,
            },
        },
    },
);
